import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CompleteBG from './complete_bg.svg'

const Complete = props => {
    let { subscribeData, subscribeInfo } = props
    let { success_url } = subscribeData
    let {
        action_id,
        complete_success,
        complete_investor_address,
    } = subscribeInfo
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    return (
        <div className="upshot-wrap">
            <div className="upshot-wrap__circle upshot-wrap__circle_complete upshot-wrap__circle_first" />
            <div className="upshot-wrap__circle upshot-wrap__circle_complete upshot-wrap__circle_second" />
            <div className="upshot-wrap__circle upshot-wrap__circle_complete upshot-wrap__circle_third" />
            <div className="upshot">
                <div
                    style={{ backgroundImage: `url(${CompleteBG})` }}
                    className="upshot__header"
                >
                    <p className="upshot__title">{translation['Success']}</p>
                    <p>Request successfully completed...</p>
                </div>
                <div className="upshot__content">
                    <div className="upshot__box-wrap upshot__box-wrap_transparent" />
                    <a
                        href={`${success_url}action_id=${action_id}&complete_success=${
                            complete_success ? 1 : 0
                        }&investor_address=${complete_investor_address}`}
                    >
                        <button className="upshot__button">
                            {translation['Continue']}
                        </button>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Complete
